/**
 * Created by RKL on 21/08/2015.
 */
define('ordersMain',[
  'module',
  'logger',
  'ordersMainRouter'
], function(
  module,
  Logger
) {
	'use strict';
	
  var Orders = {
    start: function() {
      Logger.log(module, 'starting OrdersModule');
    },

    stop: function() {
      Logger.log(module, 'stopping OrdersModule');
      $('#customer-comments-sidebar-region').hide();
    }
  };

  module.exports = Orders;
});
